import { useAuth } from '../../context/AuthContext';
import Modal from './Modal';
import Button from './Button';

const SessionExpiredModal = () => {
    const { sessionExpired, setSessionExpired } = useAuth();
    return (
        <Modal isOpen={sessionExpired} onClose={() => setSessionExpired(false)} title="Session Expired"
            closeOnBackdrop={false} showCloseButton={false} size="sm"
            footer={<Button fullWidth onClick={() => setSessionExpired(false)}>Sign In Again</Button>}>
            <p className="text-gray-600 text-sm">Your session has expired. Please sign in again to continue.</p>
        </Modal>
    );
};

export default SessionExpiredModal;
